export default "__VITE_ASSET__C0CVlXJN__"